import Context from "context/appContext";
import { useContext, useEffect } from "react";
import { useState } from "react";
import { encrypt, excepcionPostal } from "utils/utils";
import { setShowHomePage } from "__test__/pages/quotation/data.mock";
import Banner from "./banner";
import ContinueProcess from "./continue-process";
import CoverageCards from "./coverage-cards";
import MapHome from "./map";
import Planflex from "./plan-flex";
import Questions from "./questions";
import SliderHome from "./slider";
import SliderClients from "./slider-clients";

// @styles 
import './styles.scss'

export default function Homepage({ data, handleChange, loadBtn, showModal }) {

    // const [valuesMap, setValuesMap] = useState({});
    const [infoMap, setInfoMap] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const { customRequest, tokenInfo, setValuesMap, homePageData } = useContext(Context);

    useEffect(() => {
        const info = data && data.find(x => x.slice_type === "map");
        setInfoMap(info || {})
    }, [data])

    const keysArrayFilter = {
        1: 'propia',
        2: 'rentas',
        3: 'propiaRentas'
    };

    

    const validate = async (values) => {
        // setShowHomePage(false)
        setIsLoading(true);
        let cpValue=''
        if (values.cp && values.cp.length > 1 && values.typeProperty) {
            const options = JSON.parse(process.env.REACT_APP_FIND_DATA_SERVICE);
            const type = values.typeProperty && keysArrayFilter[Number(values.typeProperty)];
            const body = {
                data: encrypt(JSON.stringify({
                    filter: { key: "cpvalues" },
                    projection: { _id: 0, [type]: { "$elemMatch": { "cp": String(values.cp) } } }
                }), options.key)
            };
            const res = await customRequest(options.url, options.headers, options.method, body);
            if (res && res.success && res.respuesta.length) {
                cpValue = res.respuesta[0] && res.respuesta[0][type] && res.respuesta[0][type][0];
                const value = cpValue && cpValue.value ? cpValue.value : 0;
                value && setValuesMap({ ...values, visible: true, cost: value, info: infoMap });
            }
        }
        if(!cpValue){
            showModal(excepcionPostal);
            setIsLoading(false)
            return
        }
        handleChange(null, 'validate-form');
        // setIsLoading(false);
    }

    useEffect(() => {
        homePageData && homePageData.failRequest && setIsLoading(false)
    }, [homePageData])

    const component = (item) => {
        if (item) {
            switch (item.slice_type) {
                case 'bannerContent':
                    return <Banner data={item} validate={validate} isLoading={isLoading} />
                case 'caracteristicas':
                    return <Planflex data={item} />
                case 'continuar_proceso':
                    return <ContinueProcess data={item} handleChange={handleChange} loadBtn={loadBtn} />
                case '_por_que_sura_':
                    return <SliderHome data={item} />
                case 'coberturas':
                    return <CoverageCards data={item} />
                case 'nuestros_clientes':
                    return <div className="homepage__container-wh">
                        <SliderClients data={item} /></div>
                case 'preguntas':
                    return <Questions data={item} handleChange={handleChange} />
                default:
                    return null
            }
        }
    }

    return data && tokenInfo && tokenInfo.usuarioId ? (
        // return valuesMap && valuesMap.visible ?
        //     <div className="homepage__container" key={'map'}>
        //         <MapHome valuesMap={valuesMap} setValuesMap={setValuesMap} info={infoMap} />
        //     </div> : data && tokenInfo && tokenInfo.usuarioId ? (

        <>
            {
                <div className="homepage__container" key={0}>
                    {component(data[0])}
                </div>
            }
        </>
    ) :
        (
            <>
                <div className='slider-scrolling'>
                    {data && data.map((item, index) =>
                        <div className="homepage__container" key={index}>
                            {component(item)}
                        </div>
                    )}
                </div>
            </>
        )
}